const AuthorizationChargeTypes = {
  ALL_CHARGES: "all_charges",
  ROOM_AND_TAX: "room_and_tax",
  ALL_INCIDENTALS: "all_incidentals",
  DEPOSIT: "deposit",
  CREDIT_CARD_GUARANTEE: "credit_card_guarantee",
  AMOUNT_OF: "amount_of",
  OTHER: "other"
};
export default AuthorizationChargeTypes;

export const AuthorizationChargeTypeLabels = {
  [AuthorizationChargeTypes.ALL_CHARGES]: "All Charges",
  [AuthorizationChargeTypes.ROOM_AND_TAX]: "Room and Tax",
  [AuthorizationChargeTypes.ALL_INCIDENTALS]: "All Incidentals",
  [AuthorizationChargeTypes.DEPOSIT]: "Deposit",
  [AuthorizationChargeTypes.CREDIT_CARD_GUARANTEE]: "Credit Card Guarantee",
  [AuthorizationChargeTypes.AMOUNT_OF]: "Amount Of",
  [AuthorizationChargeTypes.OTHER]: "Other"
};
